import { store } from "../../../store/store";
import { doPost as APIPost } from "../api/API";

import { debounce } from "lodash"

import { sortOrderListAccTime } from "../oms/OMSUtils";
import { listStoreDeals } from "../inventory/LoadMoreDeal";
import { updateMoengageParameters } from "./MoengageUtils";
import { extendChemistStoreData } from "../ExtendedDataUtils";
import { extendUserSubscriptionData } from "../ExtendedDataUtils";
import { getSelectedChemistStoreId } from "../chemist/ChemistStoreUtils";

import { ActivityType, minDealsToShowAllBtn } from "../../constants/AppConstants";

import {
    activtyDataSubscription, orderListSubscriptionForOrderSummary,
    consultationListSubscriptionForConsultationDetails, CacheDataToRefresh
} from "../subject-behaviour/CommonRxjsService";
import {
    isGuestTokenValid, computeMaxGenId, getPrimaryUserData, isChemistStoreLoaded,
    updateActivityList, updateAndMergeActivityData
} from "../CommonUtils";
import {
    updateFamilyData, updateUserDetails, updateWalletDetails, updateUserSubscription,
    updateWAOptInState, updateChemistData, updateOrderList, updateConsultationList, updateUserVisitedStores
} from "../redux/commonRedux";

import AppTheme from "../../../AppTheme";

const getUserData = (requestData) => {
    var params = {
        getVisitedStores: requestData?.getVisitedStores ?? false,
        pharmacyId: requestData?.pharmacyId
    };
    APIPost('accounts/v2/get_app_basic_data', params).then(
        async (response: any) => {
            if (response == null || response.errMsg)
                return
            const userData = getPrimaryUserData(response.familyData)
            userData['orderSavings'] = response.orderSavings ?? { 'totalOrders': 0, 'totalSavings': 0 }
            var subscriptionData = response?.subscriptions?.aayuCardSubscription ?
                extendUserSubscriptionData(response.subscriptions.aayuCardSubscription,
                    { userData: userData }) : {}

            if (!requestData?.skipMeoUpdate && requestData?.pharmacyId != undefined) {
                var moeCustomerId = response.familyData['familyId'];
                if (requestData?.pharmacyId)
                    moeCustomerId = response.familyData['familyId'] + '_' + requestData?.pharmacyId
                updateMoengageParameters(userData['name'], userData['phoneNumber'], moeCustomerId);
            }

            var dashboarData = {
                userData: userData,
                familyData: response.familyData,
                subscription: subscriptionData,
                visitedStores: response.visitedStores
            }
            var walletDetails = response.walletData

            updateUserDetails(dashboarData.userData);
            updateFamilyData(dashboarData.familyData);
            updateUserSubscription(dashboarData.subscription);
            updateUserVisitedStores(dashboarData.visitedStores);
            updateWalletDetails(walletDetails);
            updateWAOptInState(dashboarData.familyData['whatsappOptState'])
            localStorage.setItem('familyId', JSON.stringify(dashboarData.familyData.familyId))
        }, (error: any) => {
            if (error.hasOwnProperty('status') && error.status == 401) {
                setTimeout(() => {
                    // Redux.resetRedux();
                    // props.navigation.popToTop();
                    // props.navigation.replace('splash')
                }, (500));
            } else {
                console.log('user data: ', error); return;
            }
        })

}

const getChemistStoreData = (requestData) => {
    const _reduxState = store.getState();
    let params = {
        pharmacyId: requestData?.chemistStoreId ?? getSelectedChemistStoreId(_reduxState),
        pwa: true, fetchWebsitePosters: isChemistStoreLoaded()
    }
    if (_reduxState.isUserLogin || isGuestTokenValid()) {
        APIPost('misc/v2_get_store_data', params).
            then((response: any) => {
                if (response !== null) {
                    let storeData = extendChemistStoreData(response)
                    if (storeData.dealsData.deals && storeData.dealsData.deals.length < minDealsToShowAllBtn) {
                        listStoreDeals(_reduxState.isUserLogin, { pageNumber: 1 }).then(
                            (newDealData: any) => {
                                let deal = storeData.dealsData.deals
                                let newDeal = newDealData.deals
                                storeData.dealsData.deals = deal.concat(newDeal).slice(0, minDealsToShowAllBtn)
                                updateChemistData(storeData);
                            }
                        )
                    } else updateChemistData(storeData);
                }
            }, (error: any) => {
                console.log('chemist store data: ', error); return;
            })
    }
}

const getUserActivityList = async (requestData) => {
    const reduxState = store.getState()
    var params = {
        pwa: true,
        pid: getSelectedChemistStoreId(reduxState),
        consultationLatestGen: requestData['fetchConsultations'] ?
            computeMaxGenId(reduxState.consultationList) : null,
        orderLatestGen: requestData['fetchOrders'] ?
            computeMaxGenId(reduxState.orderList) : null
    }
    await APIPost('accounts/get_app_incremental_data', params).then(
        (response: any) => {
            if (response === null || response.status == 401)
                return;
            var updatedOrderList = response['orders'] ?? []
            var updatedConsultList = response['consultations'] ?? []
            const reduxState = store.getState();
            updatedConsultList = updateAndMergeActivityData(reduxState.consultationList,
                updatedConsultList, { activityType: ActivityType.consultation, mergeKey: 'id' })
            updatedOrderList = updateAndMergeActivityData(reduxState.orderList,
                updatedOrderList, { activityType: ActivityType.order, mergeKey: 'oid' })
            sortOrderListAccTime(updatedOrderList)
            if (response['consultations'])
                updateConsultationList(updatedConsultList)
            if (response['orders'])
                updateOrderList(updatedOrderList)
            // Must publish data once api completes so that dependents will pull data.
            orderListSubscriptionForOrderSummary.setOrderList(updatedOrderList);
            consultationListSubscriptionForConsultationDetails.setConsultList(updatedConsultList);
            let updatedActivityData = updateActivityList(updatedConsultList)
            activtyDataSubscription.setActivityData(updatedActivityData)
        }, (err: any) => { console.log("Incremental API is failed with error " + err); return; })
}

const userProfileData = debounce(getUserData, AppTheme.debouceTimeout)
const chemistStoreData = debounce(getChemistStoreData, AppTheme.debouceTimeout)
const userActivityList = debounce(getUserActivityList, AppTheme.debouceTimeout)

const postMethodsMap = {
    refreshUserProfileData: userProfileData,
    refreshChemistStoreData: chemistStoreData,
    refreshUserActivityListData: userActivityList
}

CacheDataToRefresh.getDataToRefresh().subscribe((refreshReuests) => {
    refreshReuests.forEach((request) => {
        if (request.name && postMethodsMap.hasOwnProperty(request.name)) {
            let requestData = request.requestData ?? {}
            postMethodsMap[request.name](requestData);
        }

    })
})


const RefreshCacheAction = {
    refreshUserProfileData: 'refreshUserProfileData',
    refreshChemistStoreData: 'refreshChemistStoreData',
    refreshOrderAndEconsultData: 'refreshUserActivityListData'
}
export default RefreshCacheAction
